'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var createReducer = function createReducer(defaultState, obj) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    if (obj && obj[action.type]) return obj[action.type](state, action);
    return state;
  };
};

var createRequestReducer = function createRequestReducer(prefix, defaultState, listeners) {
  var _objectSpread2;

  return createReducer(_objectSpread({
    prefix: prefix,
    pending: false,
    requestError: false,
    params: null
  }, defaultState), _objectSpread((_objectSpread2 = {}, _defineProperty__default["default"](_objectSpread2, "".concat(prefix, "_REQUEST"), function _REQUEST(state, _ref) {
    var params = _ref.params;
    return _objectSpread(_objectSpread({}, state), {}, {
      params: params || null,
      pending: true,
      requestError: null
    });
  }), _defineProperty__default["default"](_objectSpread2, "".concat(prefix, "_REQUEST_SUCCESS"), function _REQUEST_SUCCESS(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      pending: false
    });
  }), _defineProperty__default["default"](_objectSpread2, "".concat(prefix, "_REQUEST_ERROR"), function _REQUEST_ERROR(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      pending: false,
      requestError: action.error
    });
  }), _defineProperty__default["default"](_objectSpread2, "".concat(prefix, "_CLEAR_REQUEST_ERROR"), function _CLEAR_REQUEST_ERROR(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      pending: false,
      requestError: null
    });
  }), _objectSpread2), listeners));
};

var createMappedRequestReducer = function createMappedRequestReducer(prefix, designTree, listeners) {
  var _objectSpread6;

  return createReducer({}, _objectSpread((_objectSpread6 = {}, _defineProperty__default["default"](_objectSpread6, "".concat(prefix, "_REQUEST"), function _REQUEST(state, _ref2) {
    var params = _ref2.params;
    return !designTree ? _objectSpread(_objectSpread({}, state), {}, _defineProperty__default["default"]({}, params.id, {
      pending: true,
      requestError: null,
      params: params
    })) : designTree(state, params, {
      pending: true,
      requestError: null
    });
  }), _defineProperty__default["default"](_objectSpread6, "".concat(prefix, "_REQUEST_SUCCESS"), function _REQUEST_SUCCESS(state, _ref3) {
    var params = _ref3.params;
    return !designTree ? _objectSpread(_objectSpread({}, state), {}, _defineProperty__default["default"]({}, params.id, {
      pending: false,
      requestError: null,
      params: params
    })) : designTree(state, params, {
      pending: false,
      requestError: null
    });
  }), _defineProperty__default["default"](_objectSpread6, "".concat(prefix, "_REQUEST_ERROR"), function _REQUEST_ERROR(state, _ref4) {
    var error = _ref4.error,
        params = _ref4.params;
    return !designTree ? _objectSpread(_objectSpread({}, state), {}, _defineProperty__default["default"]({}, params.id, {
      pending: false,
      requestError: error,
      params: params
    })) : designTree(state, params, {
      pending: false,
      requestError: error
    });
  }), _objectSpread6), listeners));
};

var requestMiddleware = function requestMiddleware(_ref5) {
  var dispatch = _ref5.dispatch;
  return function (next) {
    return function (action) {
      if (!action.hasOwnProperty('requestPrefix')) {
        return next(action);
      }

      return new Promise(function (resolve, reject) {
        dispatch({
          type: "".concat(action.requestPrefix, "_REQUEST"),
          params: action.params
        });
        action.request().then(function (data) {
          dispatch({
            type: "".concat(action.requestPrefix, "_REQUEST_SUCCESS"),
            response: data,
            params: action.params
          });
          action.onSuccess && action.onSuccess(dispatch, data);
          resolve(data);
        })["catch"](function (error) {
          dispatch({
            type: "".concat(action.requestPrefix, "_REQUEST_ERROR"),
            error: error,
            params: action.params
          });
          action.onError && action.onError(dispatch, error);
          reject(error);
        });
      });
    };
  };
};

var clearRequestError = function clearRequestError(prefix) {
  return {
    type: "".concat(prefix, "_CLEAR_REQUEST_ERROR")
  };
};

var getValidationErrors = function getValidationErrors(state) {
  return state.requestError ? state.requestError.validation ? state.requestError.fields : {} : {};
};

exports.clearRequestError = clearRequestError;
exports.createMappedRequestReducer = createMappedRequestReducer;
exports.createReducer = createReducer;
exports.createRequestReducer = createRequestReducer;
exports.getValidationErrors = getValidationErrors;
exports.requestMiddleware = requestMiddleware;